import React, { useContext, useState } from 'react';
import { IsNullOrEmpty, IsSelectEmpty, toastMessage } from '../../core/utility';
import { post } from '../../core/client';
import { ResponseBase } from '../../models/shared/Models';
import { MakePurchaseRequest, MemberAv } from '../../models/query-member';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { QueryMemberContext } from './Context';
import Select from '../../components/inputs/select';
import Input from '../../components/inputs/text-field-input';
import { CustomButton } from '../../components/buttons';
import { Alert, Checkbox, CircularProgress, FormControlLabel } from '@mui/material';
import AuthManager from '../../core/oidc';

interface PurchaseProps {
    productLoading: boolean;
    onNewPurchase: () => void;
}

interface InputErrorModel {
    name: string;
    errorText: string;
}

const initialMakePurchaseState: MakePurchaseRequest = {
    avNo: '',
    companyAvId: '',
    productId: null,
    productName: 'Ürün',
    amount: 1,
    discountAmount: 1,
    relationTypeId: 0,
    invoiceFullName: ''
};

const PurchaseWithoutInfo = ({ productLoading, onNewPurchase }: PurchaseProps) => {

    //context
    const { member, products } = useContext(QueryMemberContext);

    const avNo = (member as MemberAv).avNo;

    // states   
    const [makePurchaseState, setMakePurchaseState] = useState<MakePurchaseRequest>(initialMakePurchaseState);
    const [loading, setLoading] = useState(false);
    const [purchaseCompleted, setPurchaseCompleted] = useState(false);

    const makePurchase = async (model: MakePurchaseRequest) => {

        if (IsNullOrEmpty(member?.avNo)) {
            toastMessage({
                messageType: 'error',
                title: "Alışveriş No bulunamadı. Tekrar deneyiniz."
            });
            return;
        }

        setLoading(true);
        const request: MakePurchaseRequest = {
            ...model,
            invoiceFullName: AuthManager.getUserName(),
            avNo: avNo,
            companyAvId: model.companyAvId === '' ? avNo : model.companyAvId
        };
        const response = await post<ResponseBase>('api/dealer/make-purchase', request);
        setLoading(false);
        if (response != null) {
            if (response.resultCode === "1") {
                setPurchaseCompleted(true);
            }
            else {
                toastMessage({
                    messageType: 'error',
                    title: "ALIŞVERİŞ SONUCU",
                    message: response.description,
                });
            }
        }
    };

    const handleNewPurchase = () => {
        setPurchaseCompleted(false);
        setMakePurchaseState(initialMakePurchaseState);
        onNewPurchase();
    }

    return (
        <>
            {!purchaseCompleted ?
                <React.Fragment>
                    <Grid container>
                        <FormControlLabel control={<Checkbox checked disabled/>} label="Ciro belirtmek istemiyorum." />
                    </Grid>
                    <Grid container spacing={3} direction="column" alignItems="center">
                        <Grid item>
                            <CustomButton
                                text="ALIŞVERİŞİ TAMAMLA"
                                className='btn-primary mr-2'
                                disabled={loading}
                                loading={loading}
                                onClick={() => makePurchase(makePurchaseState)}
                            />
                        </Grid>
                    </Grid>
                </React.Fragment>
                : <div className="purchase-success">
                    <Grid container spacing={3} direction="column" justifyContent="center" alignItems="center">
                        <Grid item style={{ textAlign: 'center' }}>
                            <h3 className="mb-4">İşlem Başarılı!</h3>
                            <p className="mb-4" style={{ fontSize: 16 }}>Alışveriş tamamlanmıştır</p>
                            <h5><strong>Av No: {avNo}</strong></h5>
                        </Grid>
                        <Grid item>
                            <CustomButton
                                text="Yeni Alışveriş"
                                className='btn-primary'
                                onClick={() => handleNewPurchase()}
                            />
                        </Grid>
                    </Grid>
                </div>
            }
        </>
    )
}

export default PurchaseWithoutInfo;
